import React from 'react'

export default function WalletQuicknode() {
  return (
    <div>WalletQuicknode</div>
  )
}
